import { selectCompEditState } from 'projectRedux/store';
import { articleEditAdapter } from '../adapters/articleEditAdapter';

export const {
  selectAll: selectAllArticleEdit,
  selectById: selectArticleEditById,
  selectEntities: selectArticleEditEntities,
} = articleEditAdapter.getSelectors((state) => selectCompEditState(state).articles);
